.container {
  height: calc(100vh - 9rem);
}

.topPanel {
  padding: 0.5rem 0;
}

.toolbar {
  display: flex;
  padding: 0.5rem 0;
}
@media all and (orientation: portrait) {
  .toolbar {
    width: 100%;
  }
}

.actions {
  display: flex;
  margin-left: auto;
  text-align: right;
}

.agGrid {
  position: relative;
  width: 100%;
  height: calc(100vh - 100px);
}

.columnToggles {
  font-size: 0.9rem;
  list-style-type: none;
  padding: 0;
  height: calc(100% - 2rem);
  overflow-y: scroll;
}

.header {
  float: left;
}

.loadingIcon {
  position: absolute;
  text-align: center;
  margin-top: 5rem;
}

.thumbnailCell {
  width: 225px;
  height: 100%;
}

.thumbnailWrapper {
  display: inline-block;
  float: left;
  height: 100%;
  padding: 5px 0.5rem;
}

.thumbnail {
  height: 50px;
  cursor: pointer;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.25);
}

.gridLink {
  float: left;
  padding: 0.65rem;
  color: #000;
  cursor: pointer;
  font-weight: 500;
}

.thumbnailLink {
  float: left;
  padding: 0.65rem;
  color: rgb(61, 66, 188);
  cursor: pointer;
  font-weight: 500;
  padding-left: 0.5rem;
}

.gridCell {
  float: left;
  padding: 0.65rem;
}

.gridIcon {
  margin-right: 0.5rem;
}

.gridIconLabel {
  margin-left: -0.3rem;
}

.bold {
  font-weight: 500;
}

.filterIconButton {
  padding: 0.25rem 0;
}

.filterIcon {
  height: 0.7em !important;
  width: 0.7em !important;
}

.filterOptionsHeader {
  font-weight: 600;
  font-size: 0.75rem;
  margin: 0 0 0.5rem;
}

.filterOptionsHeaderIcon {
  font-size: 0.9rem !important;
  margin: -0.2rem 0.2rem 0 0;
}

.filterOptionHeader {
  font-size: 0.75rem;
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.closeMenuButton {
  margin: 0;
}

.toggleButton {
  font-size: 0.75rem !important;
  padding: 0.25rem !important;
}

.divider {
  width: 100%;
  margin-bottom: 0.5rem !important;
}

.filterStack {
  margin-top: 0.5rem;
  z-index: 1;
}

.filterStack,
.addFilterButton {
  position: relative;
}
.filterStack::before,
.addFilterButton::before {
  content: "";
  position: absolute;
  top: 0;
  right: -1.5rem;
  bottom: -3rem;
  left: -1.5rem;
  background: #f3f3f8;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.01);
}

.filterStack:nth-child(1)::before {
  top: -1rem;
}

.filterStackOperatorToggle {
  display: inline-flex;
  justify-content: left;
  margin-bottom: 0.5rem;
}

.filterComponent {
  display: inline-flex;
  width: 100%;
  z-index: 1;
}

.addFilterButton {
  z-index: 1;
}

.addFilterButtonLabel {
  padding: 5px 2px 2px;
}

.cell {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.cellList {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
  height: 100%;
}

.cellListItem {
  margin: 0;
  padding: 0;
  line-height: 1.2rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */